import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataFuturesHub() {
  return <SectionHub sectionPath="01-market-data/futures" />;
}
